import React from "react";
import { ContainerWrapper } from "../../../Components/Utils";
import ContactInput from "./Input";

export default class JoinDetail extends React.Component {
  render() {
    return (
      <ContainerWrapper textAlign="justify" className="my-5">
      <div>
        <p>We invite you to become a member of the Global GERS ecosystem.</p>
        <p>The value Global GERS delivers its members and their ventures includes:</p>
        <ul>
          <li>Increase in local reputation and image</li>
          <li>Footholds in foreign countries</li>
          <li>World class training programs that place venture growth at the center of business processes</li>
          <li>Access to investors</li>
          <li>Cloud-based artificial intelligence and machine learning services</li>
          <li>Tools, best practices, and guides that ventures can use to stay secure online</li>
          <li>Access to global projects that consolidate global resources and positively impact local communities</li>
          <li>Access to shared resources and processes</li>
        </ul>
        <p>To learn more about becoming a member, please complete and submit the form below:</p>
      </div>
      <div id="form">
        <ContactInput />
      </div>
      </ContainerWrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Pages/Misc/Components/Join.js